export const ByzColors = {
  // Byz mavi rengi
  ByzBlue: "#2498f3",
  
  // Byz disabled renkleri
  ByzDisabledGray: "rgba(0, 0, 0, 0.38)",
  ByzDisabledBorderGray: "rgba(0, 0, 0, 0.26)",
  

} as const;

export type ByzColorKey = keyof typeof ByzColors;

